import { MapPin, Phone, Train } from "lucide-react";
import { Link } from "react-router-dom";
import { useCampusLocations } from "@/hooks/useCampusLocations";

export default function Locations() {
  const { locations, loading } = useCampusLocations();

  return (
    <div>
      <section className="bg-[#0A2540] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm font-semibold tracking-wide uppercase text-orange-400 mb-3">Locations</div>
          <h1 className="text-4xl lg:text-5xl font-display font-extrabold">Two training centres across Melbourne</h1>
          <p className="mt-3 text-lg text-slate-300 max-w-2xl">Open Monday to Saturday.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-12 space-y-8">
        {loading ? <div className="text-sm text-slate-500">Loading training centres...</div> : null}
        {!loading && locations.length === 0 ? <div className="wc-card text-sm text-slate-500">No training centres are available right now.</div> : null}
        {locations.map((l, i) => {
          const id = l.campusId ?? l.id;
          const name = l.campusName ?? l.name ?? "Training centre";
          const address = [l.addressLine1 ?? l.address, l.suburb, l.postCode].filter(Boolean).join(", ");
          const map = l.map ?? `https://www.google.com/maps?q=${encodeURIComponent(address || name)}&output=embed`;

          return (
          <div key={id} className="wc-card grid lg:grid-cols-2 gap-6 p-6" data-testid={`location-${id}`}>
            <div className="rounded-lg overflow-hidden aspect-[16/10] bg-slate-100">
              <iframe src={map} className="w-full h-full border-0" loading="lazy" title={name} />
            </div>
            <div>
              <div className="text-xs font-semibold text-orange-600 uppercase tracking-wider mb-1">Centre 0{i + 1}</div>
              <h2 className="text-3xl font-display font-extrabold text-[#0A2540]">{name}</h2>
              <div className="mt-4 space-y-2 text-sm text-slate-700">
                <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-orange-500 shrink-0" />{address || "Address unavailable"}</div>
                {l.phoneNumber ?? l.phone ? <div className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-orange-500 shrink-0" /><a href={`tel:${l.phoneNumber ?? l.phone}`} className="hover:text-[#0A2540]">{l.phoneNumber ?? l.phone}</a></div> : null}
                <div className="flex items-start gap-2"><Train className="w-4 h-4 mt-0.5 text-orange-500 shrink-0" />Public transport nearby</div>
              </div>
              <div className="mt-6 flex gap-2">
                <Link to="/calendar" className="wc-btn-primary text-sm">Book at {name}</Link>
                {l.phoneNumber ?? l.phone ? <a href={`tel:${l.phoneNumber ?? l.phone}`} className="wc-btn-outline text-sm">Call centre</a> : null}
              </div>
            </div>
          </div>
        )})}
      </section>
    </div>
  );
}
